<template>
      <div class="left side-menu">
            <div class="slimscroll-menu" id="remove-scroll">
                  
                  <!--- Sidemenu -->
                  <div id="sidebar-menu">
                        <!-- Left Menu Start -->
                        <ul class="metismenu" id="side-menu">
                              
                              <li>
                                    <a href="#/main" >
                                          <i class="fi-air-play"></i> <span> 我的主页 </span>
                                    </a>
                              </li>
                              
                              <li>
                                    <a href="javascript: void(0);"><i class="fi-briefcase"></i> <span> 考试专区 </span> <span class="menu-arrow"></span></a>
                                    <ul class="nav-second-level" aria-expanded="false">
                                          <li><a href="#/signup" >考试报名</a></li>
                                    </ul>
                              </li>
                              
                              <li>
                                    <a href="javascript: void(0);"><i class="fi-box"></i><span> 认证专区 </span> <span class="menu-arrow"></span></a>
                                    <ul class="nav-second-level" aria-expanded="false">
                                          <li><a href="#/Authentication">首次认证</a></li>
                                          <li><a href="#/Authentication2" >再认证</a></li>
                                    </ul>
                              </li>
                              
                              <li>
                                    <a href="javascript: void(0);"><i class="fi-bar-graph-2"></i><span style="color: #cccccc"> 会员活动 </span> <span class="menu-arrow"></span></a>
                                    
                              </li>
                              
                              <li>
                                    <a href="javascript: void(0);"><i class="fi-mail"></i><span style="color: #cccccc"> 我的账户 </span> <span class="menu-arrow"></span></a>
                                    
                              </li>
                              <!--
                              <li>
                                    <a href="javascript: void(0);"><i class="fi-disc"></i><span class="badge badge-warning pull-right">09</span> <span> Forms </span></a>
                                    <ul class="nav-second-level" aria-expanded="false">
                                          <li><a href="form-elements.html">Form Elements</a></li>
                                          <li><a href="form-advanced.html">Form Advanced</a></li>
                                          <li><a href="form-validation.html">Form Validation</a></li>
                                          <li><a href="form-pickers.html">Form Pickers</a></li>
                                          <li><a href="form-wizard.html">Form Wizard</a></li>
                                          <li><a href="form-mask.html">Form Masks</a></li>
                                          <li><a href="form-wysiwig.html">Wysiwig Editors</a></li>
                                          <li><a href="form-x-editable.html">X Editable</a></li>
                                          <li><a href="form-uploads.html">Multiple File Upload</a></li>
                                    </ul>
                              </li>
                              
                              <li>
                                    <a href="javascript: void(0);"><i class="fi-layout"></i> <span> Tables </span> <span class="menu-arrow"></span></a>
                                    <ul class="nav-second-level" aria-expanded="false">
                                          <li><a href="tables-basic.html">Basic Tables</a></li>
                                          <li><a href="tables-datatable.html">Data Tables</a></li>
                                          <li><a href="tables-responsive.html">Responsive Table</a></li>
                                          <li><a href="tables-tablesaw.html">Tablesaw Tables</a></li>
                                          <li><a href="tables-editable.html">Editable Tables</a></li>
                                    </ul>
                              </li>
                              -->
                              
                              <li class="menu-title">More</li>
                              <li><a href="#/password"><i class="fi-map"></i> <span>修改密码</span> </a></li>
                              <li><a href="#/loginout"><i class="fi-clock"></i> <span>退出登录</span> </a></li>
                              <!--
                              <li>
                                    <a href="javascript: void(0);"><i class="fi-map"></i> <span> Maps </span> <span class="menu-arrow"></span></a>
                                    <ul class="nav-second-level" aria-expanded="false">
                                          <li><a href="maps-google.html">Google Maps</a></li>
                                          <li><a href="maps-vector.html">Vector Maps</a></li>
                                          <li><a href="maps-mapael.html">Mapael Maps</a></li>
                                    </ul>
                              </li>
                              
                              
                              
                              <li>
                                    <a href="javascript: void(0);"><i class="fi-paper-stack"></i><span> Pages </span> <span class="menu-arrow"></span></a>
                                    <ul class="nav-second-level" aria-expanded="false">
                                          <li><a href="page-starter.html">Starter Page</a></li>
                                          <li><a href="page-login.html">Login</a></li>
                                          <li><a href="page-register.html">Register</a></li>
                                          <li><a href="page-logout.html">Logout</a></li>
                                          <li><a href="page-recoverpw.html">Recover Password</a></li>
                                          <li><a href="page-lock-screen.html">Lock Screen</a></li>
                                          <li><a href="page-confirm-mail.html">Confirm Mail</a></li>
                                          <li><a href="page-404.html">Error 404</a></li>
                                          <li><a href="page-404-alt.html">Error 404-alt</a></li>
                                          <li><a href="page-500.html">Error 500</a></li>
                                    </ul>
                              </li>
                              
                              <li>
                                    <a href="javascript:void(0);"><i class="fi-marquee-plus"></i><span class="badge badge-success pull-right">Hot</span> <span> Extra Pages </span></a>
                                    <ul class="nav-second-level" aria-expanded="false">
                                          <li><a href="extras-timeline.html">Timeline</a></li>
                                          <li><a href="extras-invoice.html">Invoice</a></li>
                                          <li><a href="extras-faq.html">FAQ</a></li>
                                          <li><a href="extras-pricing.html">Pricing</a></li>
                                          <li><a href="extras-email-template.html">Email Templates</a></li>
                                    </ul>
                              </li>
                              
                              <li>
                                    <a href="javascript: void(0);"><i class="fi-share"></i> <span> Multi Level </span> <span class="menu-arrow"></span></a>
                                    <ul class="nav-second-level nav" aria-expanded="false">
                                          <li><a href="javascript: void(0);">Level 1.1</a></li>
                                          <li><a href="javascript: void(0);" aria-expanded="false">Level 1.2 <span class="menu-arrow"></span></a>
                                                <ul class="nav-third-level nav" aria-expanded="false">
                                                      <li><a href="javascript: void(0);">Level 2.1</a></li>
                                                      <li><a href="javascript: void(0);">Level 2.2</a></li>
                                                </ul>
                                          </li>
                                    </ul>
                              </li>
                              -->
                        
                        </ul>
                  
                  </div>
                  <!-- Sidebar -->
                  <div class="clearfix"></div>
            
            </div>
            <!-- Sidebar -left -->
      
      </div>

</template>

<script>
      export default {
            name: 'left',
            methods:{
            
            },
            data(){
                  return{
                        i:0,
                  }
            },
     
            mounted() {
            
            },
            methods:{
                  goto:function(url) {
                        window.location.href=url
                  }
            }
           

      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

  
     
</style>



// WEBPACK FOOTER //
// src/components/left.vue